// extracted by mini-css-extract-plugin
export default {"mobileNavbar":"navbar_mobileNavbar__NkMXh"};